<template>
  <v-main>
    <v-container fluid>
    <!-- Generamos el AppBar con las distintas acciones -->
    <v-app-bar color="primary" dense dark style="border-radius: 5px">
      <!-- Crear una nuevo cliente -->
      <v-btn v-if="user_is_admin" text @click="dialog_formulario = true">
        <v-icon>mdi-account-plus-outline</v-icon>
        <span class="appbar_button">{{ $t('Nuevo') }}</span>
      </v-btn>
      <!-- Reordenar empleados -->
      <v-btn v-if="user_is_admin" text @click="dialog_ordenar = true">
        <v-icon>mdi-menu-swap</v-icon>
        <span class="appbar_button">{{ $t('Orden en la agenda') }}</span>
      </v-btn>
      <v-spacer />
        <v-btn icon href="https://www.youtube.com/playlist?list=PL2a9kD1kP16dTMApbdGWurQ0kC-iKrip_">
            <v-icon>mdi-video</v-icon>
        </v-btn>
    </v-app-bar>

      <v-expansion-panels focusable class="my-4">
        <v-expansion-panel>
          <v-expansion-panel-header class="titulo_buscador">
            <span>
              <v-icon large>mdi-magnify</v-icon>
              {{ $t("Buscar") }}
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form>
              <v-row class="mt-0" align="center">
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <Buscador @search="buscar_empleados"/>
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <v-switch v-model="filtros_buscador.is_active" dense hide-details class="ma-0 my-1"
                              :label="$t('Solo activos')"/>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="container_info_azul" v-if="$store.state.centro.centro.limite_empleados && user_is_admin && $store.state.centro.centro.plan_contratado !== CONSTANTS.PLANES_KOIBOX.LITE">
        <v-row class="ma-0" justify="space-between">
          <v-col class="pa-0" cols="12" md="7">
            <p>{{
                $t('Actualmente su centro tiene un límite de [EMPLEADOS] empleados.').replace('[EMPLEADOS]', $store.state.centro.centro.limite_empleados)
              }}</p>
            <span>{{
                $t('Puedes contratar un pack de 5 empleados más por tan solo 5€/mes (impuestos no incluidos).')
              }}</span>
          </v-col>
          <v-col cols="12" md="5" class="text-md-end">
            <v-btn color="red" class="white--text" small @click="contratar_plan_empleados">
              <v-icon class="mr-2" color="white" small>mdi-account-cash</v-icon>
              {{ $t('Contratar pack de 5 empleados') }}
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-data-table
          :headers="tabla.headers"
          :items="tabla.empleados"
          :options.sync="tabla.options"
          :server-items-length="tabla.count"
          :fixed-header="true"
          class="elevation-3"
          calculate-widths
          :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
      >
        <!-- Foto del empleado -->
        <template v-slot:item.foto_url_absolute_path="{ item }">
          <v-list-item-avatar height="55" width="55" :style="'border: 3px solid' + item.color + '!important'">
            <v-img :src="item.foto_url_absolute_path" alt="" />
          </v-list-item-avatar>
        </template>

        <!-- Rol del empleado -->
        <template v-slot:item.tipo_empleado="{ item }">
<!--          <v-icon v-if="user_is_admin" color="orange" title="El usuario tiene acceso administrativo."> mdi-account-star </v-icon>-->
<!--          <v-icon v-else color="primary"> mdi-account </v-icon>-->
          <span> {{ tabla.tipos_empleado[item.tipo_empleado] }}</span>
        </template>

        <!-- Fecha del último acceso -->
        <template v-slot:item.last_login="{ item }">
          <span v-if="item.last_login">{{ new Date(item.last_login).toLocaleString() }}</span>
        </template>

        <!-- Activo -->
        <template v-slot:item.is_active="{ item }">
          <v-icon v-if="!item.is_active" color="red"> mdi-account-cancel</v-icon>
          <v-icon v-else color="green"> mdi-account-check</v-icon>
        </template>

        <!-- Actions -->
        <template v-slot:item.actions="{ item }">
          <v-btn icon color="primary" @click="$router.push({name: 'ficha_empleado', params: {id: item.id, is_active: filtros_buscador.is_active}})"
                 :title="$t('Editar')">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <!-- Dialog de ordenar empleados -->
      <DialogOrdenarEmpleados v-if="dialog_ordenar" v-model="dialog_ordenar"
                              @on_save="(empleados) => {this.empleados = empleados}"/>

      <!-- Dialog contratar distribuidor -->
      <DialogContratarDistribuidor
        ref="dialog_contratar_distribuidor"
      />

      <!-- Dialog de crear nuevo empleado -->
      <FormEmpleado v-if="dialog_formulario" v-model="dialog_formulario" :is_admin="is_admin" @on_save="get_empleados()"/>

<!--      para rellenar los datos de facturacion-->
      <FormCentro
          v-model="show_form_centro"
          v-if="show_form_centro"
          :titulo="$t('Antes de continuar, rellena los datos fiscales de tu centro')"
          tab="tab-datos-fiscales"
          @on_save="this.contratar_plan_empleados" />

    </v-container>
  </v-main>
</template>


<script>
import CONSTANTS from "@/utils/constants";

export default {
  name: 'Empleados',
  data: () => ({
    // Variables para los dialog
    dialog_ordenar: false,
    dialog_formulario: false,
    show_form_centro: false,
    // Filtros del buscador
    filtros_buscador: { is_active: true},
    // Tabla
    tabla: {
      empleados: [],
      count: 0,
      headers: [],
      options: {
        itemsPerPage: localStorage.getItem('itemsPerPage') ? parseInt(localStorage.getItem('itemsPerPage')) :  10
      },
      filtros: {},
      tipos_empleado: {}
    },
  }),
  // Observamos el campo
  watch: {
    'filtros_buscador.is_active':{
      handler() {
        this.get_empleados()
      }
    },
    'tabla.options': {
      handler(value, oldValue){
        if(value.itemsPerPage !== oldValue.itemsPerPage){
          try{
            localStorage.setItem('itemsPerPage', value.itemsPerPage)
          }catch (e){}
        }
        // Cambiamos los params de la busqueda
        this.tabla.filtros.limit = value.itemsPerPage
        this.tabla.filtros.offset = ((value.page - 1) * value.itemsPerPage)

        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.tabla.filtros.ordering = `${desc}${value.sortBy[0]}`
        }
        this.get_empleados()
      }
    },
  },

  computed: {
    CONSTANTS() {
      return CONSTANTS
    },
    is_admin: function () {
      return this.$store.state.auth.user.tipo_empleado === 'admin'
    },
    user_is_admin: function (){
      return this.$store.state.auth.user.tipo_empleado === 'admin'
    },
    centro: function(){
      return this.$store.state.centro.centro
    }
  },

  methods: {

    async contratar_plan_empleados(){
      // Comprobamos que el centro no sea de Sebymar
      if(this.centro.distribuidor === CONSTANTS.DISTRIBUIDORES.SEBYMAR){
        const distribuidor = this.centro.distribuidor_obj
        this.$refs.dialog_contratar_distribuidor.open_dialog(distribuidor)
        return
      }


      const PACK_EMPLEADOS_ID = 6
      const plan = await this.$store.dispatch('planes_koibox/get_plan', PACK_EMPLEADOS_ID)
      let cuota = plan.cuota_mensual_con_impuestos
      const cuota_sin_impuestos = plan.cuota_mensual_sin_impuestos
      let texto_impuestos = this.$t('Impuestos incluidos')
      if (!this.centro.is_tiene_impuestos){
        cuota = plan.cuota_mensual_sin_impuestos
        texto_impuestos = ''
      }
      if (this.centro.is_premium && (!this.centro.razon_social || !this.centro.cif || !this.centro.localidad_social || !this.centro.provincia_social
          ||!this.centro.direccion_social ||!this.centro.codigo_postal_social)) {
        this.show_form_centro= true
        return
      }
      const confirm = await this.$fire({
        title: this.$t('¿Contratar {plan}?',{plan: plan.text}),
        html: `${this.$t('Suscripción mensual: {cuota}€/mes', { cuota })}. ${texto_impuestos}.`,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: this.$t('Contratar'),
        cancelButtonText: this.$t('Cancelar'),
      })

      if(confirm.value === true){
        try{
          await this.$store.dispatch('planes_koibox/contratacion_plan_empleados')
          this.$snotify.success(
              this.$t("Acción realizada con éxito."),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )

          // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#purchase
          this.$gtag.event('purchase', {
            'currency': 'EUR',
            'transaction_id': crypto.randomUUID(),
            'value': cuota_sin_impuestos,
            'items': [
              {
                'item_name': plan.text,
                'item_category': 'Mensual',
                'price': cuota_sin_impuestos
              }
            ]
          });

        }catch (err){
          this.$snotify.error(
              this.$t('Ha ocurrido un error'),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }
    },


    /**
     * Devuelve los empleados del centro del usuario.
     */
    async get_empleados() {
      try {
        const filtros = {...this.tabla.filtros, ...this.filtros_buscador}
        if(filtros['ordering']==='nombre_completo' || filtros['ordering']==='-nombre_completo'){
          filtros['ordering'] = filtros['ordering'] === 'nombre_completo'? 'first_name' : '-first_name'
        }
        if(filtros['is_active'] === false){
          delete filtros['is_active']
        }
        const response = await this.$store.dispatch('user/get_empleados', filtros)
        this.tabla.count = response.count
        this.tabla.empleados = response.results
      } catch (err) {
	      this.$snotify.error(
		      this.$t("Ha ocurrido un error"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
      }
    },
    /**
     * Busca los empleados cuando el usuario escribe en la barra buscadora.
     * @param search String
     * */
    buscar_empleados(search) {
      this.filtros_buscador['nombre__icontains'] = search
      this.tabla.options.page = 1
      this.tabla.filtros.offset = 0
      this.get_empleados()
    },
  },

  mounted() {
    this.tabla.headers = [
      {text: '', value: 'foto_url_absolute_path', class: "primary white--text", width: "60px", sortable: false},
      {text: this.$t('Nombre'), value: 'nombre_completo', class: "primary white--text"},
      {text: this.$t('Email'), value: 'email', class: "primary white--text"},
      {text: this.$t('Rol'), value: 'tipo_empleado', class: "primary white--text"},
      {text: this.$t('Accesos'), value: 'accesos', class: "primary white--text"},
      {text: this.$t('Fecha últ. acceso'), value: 'last_login', class: "primary white--text"},
      {text: this.$t('IP acceso'), value: 'ip_acceso', class: "primary white--text"},
      {text: this.$t('Activo'), value: 'is_active', class: "primary white--text", width: '85px'},
      {text: this.$t('Editar'), value: 'actions', class: "primary white--text", width: '10px', sortable: false},
    ]
    this.tabla.tipos_empleado = {
      'empleado': this.$t('Empleado'),
      'admin': this.$t('Administrador'),
      'contabilidad': this.$t('Contabilidad'),
      'marketing': this.$t('Marketing')
    }
  },

  // Importamos los Dialogs
  components: {
    // Dialogs
    DialogOrdenarEmpleados: () => import("@/views/Configuracion/Empleados/components/DialogOrdenarEmpleados"),
    DialogContratarDistribuidor: () => import('@/components/shared/DialogContratarDistribuidor'),
    FormEmpleado: () => import("@/views/Configuracion/Empleados/components/FormEmpleado"),
    FormCentro: () => import("@/views/Configuracion/Centro/FormCentro"),
  }
}
</script>
